import axios from '@/libs/api.request'
// 列表
export const apiCustReferrerList = data => {
  return axios.request({
    url: '/custreferrer/list',
    method: 'post',
    data
  })
}

// 删除
export const apiCustReferrerDelete = data => {
  return axios.request({
    url: `/custreferrer/delete`,
    method: 'post',
    data
  })
}
// 保存
export const apiCustReferrerSave = data => {
  return axios.request({
    url: `/custreferrer/save`,
    method: 'post',
    data
  })
}
